// Animated "live tracking" illustration for the search page.
// Ported verbatim from the Claude Design file "Track Parcel.dc.html"
// (buildMap + tick); only asset URLs, keyframe names and the rider copy differ.

import blitzMark from "../../../assets/images/blitz-mark.svg";

function blk(x, y, w, h) {
  return '<rect x="' + x + '" y="' + (y + 5) + '" width="' + w + '" height="' + h + '" rx="6" fill="#D3DFFF"/><rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="6" fill="#E7EEFF"/><rect x="' + (x + 8) + '" y="' + (y + 8) + '" width="' + Math.max(8, w * 0.3) + '" height="6" rx="3" fill="#F3F6FF"/>';
}

const ROUTE = "M40 300 L190 300 Q206 300 206 284 L206 200 Q206 184 190 184 L110 184 Q94 184 94 168 L94 100 Q94 84 110 84 L372 84";

function buildMap() {
  const roads = ["M0 84 H520", "M0 184 H330", "M0 300 H520", "M94 0 V440", "M206 84 V440", "M330 84 V440"];
  const blocks = [[0, 0, 76, 66], [112, 0, 124, 66], [248, 0, 124, 66], [0, 102, 76, 64], [112, 102, 76, 64], [224, 102, 88, 64], [112, 202, 76, 80], [224, 202, 88, 80], [0, 318, 76, 122], [112, 318, 76, 122], [224, 318, 88, 122], [348, 318, 172, 122]].map((r) => blk(...r)).join("");
  const trees = [[372, 128, 14], [404, 150, 11], [470, 124, 13], [500, 160, 10], [380, 240, 12], [440, 258, 14], [492, 232, 11], [420, 196, 9]].map(([x, y, r]) => '<circle cx="' + x + '" cy="' + (y + 3) + '" r="' + r + '" fill="#9FD3B2"/><circle cx="' + x + '" cy="' + y + '" r="' + r + '" fill="#BFE6CD"/><circle cx="' + (x - r * 0.3) + '" cy="' + (y - r * 0.3) + '" r="' + r * 0.35 + '" fill="#D6F0DF"/>').join("");
  const cap = (cx, cy) => '<path d="M' + (cx - 5.6) + " " + (cy - 1) + " A5.6 5.6 0 0 1 " + (cx + 5.6) + " " + (cy - 1) + " L" + (cx + 10) + " " + (cy - 1) + " Q" + (cx + 10) + " " + (cy + 1) + " " + (cx + 8) + " " + (cy + 1) + " L" + (cx - 5.6) + " " + (cy + 1) + ' Z" fill="#7130F0"/>';
  return `
<svg viewBox="0 0 520 440" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" style="display:block;position:absolute;inset:0" aria-hidden="true">
<defs><linearGradient id="bRt" x1="0" y1="1" x2="1" y2="0"><stop offset="0" stop-color="#7130F0"/><stop offset="1" stop-color="#8E9BFF"/></linearGradient></defs>
<rect width="520" height="440" fill="#EDF2FB"/>
${roads.map((d) => '<path d="' + d + '" stroke="#fff" stroke-width="26" fill="none"/>').join("")}
${roads.map((d) => '<path d="' + d + '" stroke="#E1E7F3" stroke-width="1.5" stroke-dasharray="6 8" fill="none"/>').join("")}
${blocks}
<rect x="348" y="102" width="172" height="180" rx="10" fill="#E2F3E8"/>
<path d="M348 196 Q400 176 430 210 T520 214" stroke="#F4FAF6" stroke-width="7" fill="none" stroke-linecap="round"/>
${trees}
${blk(0, 202, 76, 80)}
<rect x="22" y="222" width="32" height="32" rx="7" fill="#111827"/>
<image href="${blitzMark}" x="23" y="223" width="30" height="30"/>
<rect x="18" y="262" width="40" height="14" rx="3" fill="#D3DFFF"/>
<g>
  <path d="M390 26 L448 3 L506 26 Z" fill="#C9B8F7"/>
  <rect x="396" y="24" width="104" height="47" fill="#fff" stroke="#D3DFFF" stroke-width="1.5"/>
  <rect x="406" y="34" width="20" height="15" rx="2" fill="#DCE6FF"/><path d="M416 34 V49 M406 41.5 H426" stroke="#fff" stroke-width="1.5"/>
  <rect x="470" y="34" width="20" height="15" rx="2" fill="#DCE6FF"/><path d="M480 34 V49 M470 41.5 H490" stroke="#fff" stroke-width="1.5"/>
  <ellipse id="bz-glow" cx="447" cy="78" rx="22" ry="7" fill="#FFD166" opacity="0"/>
  <rect x="435" y="41" width="24" height="30" rx="1.5" fill="#1B3B6F"/>
  <rect x="437" y="43" width="20" height="28" fill="#FFE3A1"/>
  <g id="bz-door"><rect x="437" y="43" width="20" height="28" fill="#7130F0"/><rect x="440" y="46" width="14" height="9" rx="1" fill="#8A55F4"/><rect x="440" y="58" width="14" height="10" rx="1" fill="#8A55F4"/><circle cx="453.5" cy="58" r="1.4" fill="#fff"/></g>
  <rect x="431" y="71" width="32" height="4" rx="1.5" fill="#C9B8F7"/>
  <circle cx="447" cy="77" r="6" fill="#7130F0" opacity="0"><animate attributeName="r" values="6;20" dur="2s" repeatCount="indefinite"/><animate attributeName="opacity" values=".3;0" dur="2s" repeatCount="indefinite"/></circle>
</g>
<path d="${ROUTE}" fill="none" stroke="#C9D5F5" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 9"/>
<path d="M376 88 L424 88 L424 76" fill="none" stroke="#C9B8F7" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="1 6"/>
<path id="bz-route" d="${ROUTE}" fill="none" stroke="none"/>
<path id="bz-prog" d="${ROUTE}" pathLength="100" fill="none" stroke="url(#bRt)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="100 100" stroke-dashoffset="100"/>
<circle cx="40" cy="300" r="6" fill="#fff" stroke="#7130F0" stroke-width="3"/>
<g id="bz-check" transform="translate(466 36) scale(0)">
  <circle r="10" fill="#16A34A" stroke="#fff" stroke-width="2"/><path d="M-4.5 0 L-1.5 3 L4.5 -3.5" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<g id="bz-rider" style="filter:drop-shadow(0 3px 4px rgba(27,59,111,.28))">
  <ellipse cx="0" cy="1" rx="26" ry="3.5" fill="#1B3B6F" opacity=".16"/>
  <g id="bz-side"><g transform="scale(.9)">
    <rect x="-37" y="-51" width="25" height="23" rx="3.5" fill="#111827"/>
    <image href="${blitzMark}" x="-35.5" y="-50" width="22" height="21"/>
    <g id="bz-rb1">
      <path d="M-9 -31 L-5 -45" stroke="#111827" stroke-width="9" stroke-linecap="round"/>
      <path d="M-4 -43 L15 -36" stroke="#111827" stroke-width="4" stroke-linecap="round"/>
      <circle cx="-3" cy="-53" r="5.5" fill="#111827"/>${cap(-3, -53)}
    </g>
    <path d="M-28 -9 C-29 -19 -22 -25 -10 -25 L3 -25 C5 -25 5 -21 4 -18 L4 -13 L13 -13 L18 -36 L22 -36 L19 -17 C24 -15 27 -11 27 -9 Z" fill="#7130F0"/>
    <rect x="-21" y="-30" width="21" height="5.5" rx="2.75" fill="#111827"/>
    <path id="bz-rb2" d="M-8 -30 L5 -29 L8 -15" fill="none" stroke="#111827" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 -37 L24 -37" stroke="#111827" stroke-width="3" stroke-linecap="round"/>
    <circle cx="22.5" cy="-32" r="2" fill="#FFD166"/>
    <path d="M-24 -16 L-6 -16" stroke="#fff" stroke-width="1.6" stroke-linecap="round" opacity=".7"/>
    <circle cx="-17" cy="-7" r="7" fill="#111827"/><circle cx="-17" cy="-7" r="2.5" fill="#fff"/>
    <circle cx="19" cy="-7" r="7" fill="#111827"/><circle cx="19" cy="-7" r="2.5" fill="#fff"/>
  </g></g>
  <g id="bz-back" style="display:none"><g transform="scale(.9)">
    <path d="M-16 -40 L16 -40" stroke="#111827" stroke-width="3" stroke-linecap="round"/>
    <circle cx="-17" cy="-43" r="2.4" fill="#111827"/><circle cx="17" cy="-43" r="2.4" fill="#111827"/>
    <rect x="-8.5" y="-50" width="17" height="22" rx="7" fill="#111827"/>
    <path d="M-7 -45 L-15 -40 M7 -45 L15 -40" stroke="#111827" stroke-width="4" stroke-linecap="round"/>
    <circle cx="0" cy="-56" r="6" fill="#111827"/><path d="M-6 -57 A6 6 0 0 1 6 -57 Z" fill="#7130F0"/>
    <rect x="-3.5" y="-14" width="7" height="14" rx="3.5" fill="#111827"/>
    <path d="M-14 -12 Q-14 -25 0 -26 Q14 -25 14 -12 Q14 -8 10 -8 L-10 -8 Q-14 -8 -14 -12 Z" fill="#7130F0"/>
    <rect x="-13" y="-44" width="26" height="24" rx="3.5" fill="#111827"/>
    <image href="${blitzMark}" x="-12" y="-43" width="24" height="22"/>
    <rect x="-5" y="-15" width="10" height="3" rx="1.5" fill="#FF5A5F"/>
  </g></g>
</g>
<g id="bz-walker" opacity="0" style="filter:drop-shadow(0 3px 4px rgba(27,59,111,.28))"><g transform="scale(.9)">
  <ellipse cx="0" cy="1" rx="9" ry="2.5" fill="#1B3B6F" opacity=".18"/>
  <g id="bz-legB"><path d="M0 -20 L0 -2 L4 -2" fill="none" stroke="#2A3550" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round"/></g>
  <g id="bz-legA"><path d="M0 -20 L0 -2 L4 -2" fill="none" stroke="#111827" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round"/></g>
  <path d="M0 -21 L0 -36" stroke="#111827" stroke-width="10" stroke-linecap="round"/>
  <circle cx="1" cy="-44" r="5.5" fill="#111827"/>${cap(1, -44)}
  <g id="bz-parcel">
    <rect x="5" y="-35" width="15" height="13" rx="2" fill="#D9A867"/>
    <rect x="5" y="-30" width="15" height="2.5" fill="#7130F0"/>
  </g>
  <path d="M1 -33 L10 -28" stroke="#111827" stroke-width="3.5" stroke-linecap="round"/>
</g></g>
</svg>
<div style="position:absolute;left:5%;top:5.5%;display:flex;align-items:center;gap:8px;padding:6px 12px;background:#fff;border-radius:999px;box-shadow:0 4px 14px rgba(27,59,111,.1);font:500 12px Poppins,sans-serif;color:#111827">
  <span style="width:7px;height:7px;border-radius:50%;background:#E5484D;animation:bzBlink 1.4s infinite"></span>Live
</div>
<div style="position:absolute;left:4%;right:4%;bottom:4%;animation:bzFloat 5s ease-in-out infinite">
  <div style="display:flex;align-items:center;gap:clamp(10px,3vw,14px);padding:clamp(10px,2.6vw,14px) clamp(12px,3vw,16px);background:#fff;border-radius:clamp(12px,3vw,16px);box-shadow:0 14px 34px -10px rgba(27,59,111,.28);font-family:Poppins,sans-serif">
    <div style="width:clamp(34px,9vw,42px);height:clamp(34px,9vw,42px);border-radius:10px;background:#F1EAFF;display:flex;align-items:center;justify-content:center;flex:none">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7130F0" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>
    </div>
    <div style="display:flex;flex-direction:column;gap:2px;min-width:0;flex:1">
      <span id="bz-title" style="font-size:14px;font-weight:600;color:#111827">Out for delivery</span>
      <span id="bz-sub" style="font-size:12px;line-height:1.4;color:#5B6478">Arriving today by 2:40 PM</span>
    </div>
    <div style="display:flex;gap:4px;flex:none">
      <span style="width:18px;height:4px;border-radius:2px;background:#7130F0"></span>
      <span style="width:18px;height:4px;border-radius:2px;background:#7130F0"></span>
      <span style="width:18px;height:4px;border-radius:2px;background:#7130F0"></span>
      <span id="bz-d4" style="width:18px;height:4px;border-radius:2px;background:#DDE3F0;transition:background .4s"></span>
    </div>
  </div>
</div>`;
}

// Built once: React must never re-render this markup, or the cached node
// references used by the animation loop would go stale.
export const MAP_HTML = buildMap();

const cl = (v) => Math.max(0, Math.min(1, v));
const eio = (x) => 0.5 - 0.5 * Math.cos(Math.PI * cl(x));

const PHASES = [
  ["Out for delivery", "Arriving today by 2:40 PM", "#DDE3F0"],
  ["Rider has arrived", "Rider is at your door with your parcel", "#DDE3F0"],
  ["Delivered", "Handed over at 2:31 PM", "#7130F0"],
];

const NODE_KEYS = ["route", "prog", "rider", "side", "back", "rb1", "rb2", "walker", "legA", "legB", "door", "glow", "check", "parcel", "title", "sub", "d4"];

// Runs the 14 s loop: ride the route (0-7 s), park and walk the parcel to the
// door (7.3-10.1 s), door opens and parcel is handed over (10.1-11.2 s),
// delivered tick, then fade and restart. Returns a stop function.
export function startScene(root) {
  const q = {};
  NODE_KEYS.forEach((k) => (q[k] = root.querySelector("#bz-" + k)));
  if (!q.route) return () => {};

  const len = q.route.getTotalLength();
  const scene = { t0: null, phase: -1, key: "R", turnAt: 0 };
  let raf;

  const tick = (now) => {
    raf = requestAnimationFrame(tick);
    if (scene.t0 == null) scene.t0 = now;
    const t = ((now - scene.t0) / 1000) % 14;
    const fade = t < 0.4 ? t / 0.4 : t > 13.2 ? cl((14 - t) / 0.8) : 1;
    const p = eio(t / 7), l = p * len;
    const pt = q.route.getPointAtLength(l);
    const p1 = q.route.getPointAtLength(Math.max(0, l - 1.5)), p2 = q.route.getPointAtLength(Math.min(len, l + 1.5));
    let dx = p2.x - p1.x, dy = p2.y - p1.y;
    if (t >= 6.9 || t < 0.05) { dx = 1; dy = 0; }
    const key = Math.abs(dx) >= Math.abs(dy) ? (dx < 0 ? "L" : "R") : "U";
    if (key !== scene.key) { scene.key = key; scene.turnAt = now; }
    const sq = 0.5 + 0.5 * eio((now - (scene.turnAt || 0)) / 240);
    const moving = t > 0.2 && t < 6.9;
    const bob = moving ? Math.sin(now / 70) * 0.7 : 0;
    q.rider.setAttribute("transform", "translate(" + pt.x + " " + (pt.y + 5 + bob) + ")");
    q.side.style.display = key === "U" ? "none" : "";
    q.back.style.display = key === "U" ? "" : "none";
    q.side.setAttribute("transform", "scale(" + ((key === "L" ? -1 : 1) * sq) + " 1)");
    q.back.setAttribute("transform", "scale(" + sq + " 1)");
    q.rider.setAttribute("opacity", fade);
    q.prog.setAttribute("stroke-dashoffset", 100 * (1 - p));
    q.prog.setAttribute("opacity", fade);
    const off = t >= 7.3;
    q.rb1.style.display = off ? "none" : "";
    q.rb2.style.display = off ? "none" : "";
    let wx = 368, wy = 89, walking = false;
    if (t >= 7.3 && t < 7.8) { const k = (t - 7.3) / 0.5; wx = 368 + 12 * k; wy = 89 - Math.sin(Math.PI * k) * 6; }
    else if (t >= 7.8 && t < 9.6) { wx = 380 + 44 * eio((t - 7.8) / 1.8); walking = true; }
    else if (t >= 9.6 && t < 10.1) { wx = 424; wy = 89 - 13 * eio((t - 9.6) / 0.5); walking = true; }
    else if (t >= 10.1) { wx = 424; wy = 76; }
    const ph = (now / 1000) * 11;
    const a = walking ? Math.sin(ph) * 28 : 0;
    const wb = walking ? -Math.abs(Math.sin(ph)) * 1.3 : 0;
    q.walker.setAttribute("transform", "translate(" + wx + " " + (wy + wb) + ")");
    q.walker.setAttribute("opacity", t < 7.3 ? 0 : cl((t - 7.3) / 0.25) * fade);
    q.legA.setAttribute("transform", "rotate(" + a + " 0 -20)");
    q.legB.setAttribute("transform", "rotate(" + -a + " 0 -20)");
    const open = t < 12.8 ? eio((t - 10.1) / 0.5) : 1 - eio((t - 12.8) / 0.6);
    q.door.setAttribute("transform", "translate(437 0) scale(" + (1 - 0.82 * open) + " 1) translate(-437 0)");
    q.glow.setAttribute("opacity", 0.55 * open);
    const hand = eio((t - 10.6) / 0.5);
    q.parcel.setAttribute("transform", "translate(" + 9 * hand + " " + -2 * hand + ")");
    q.parcel.setAttribute("opacity", 1 - cl((t - 10.9) / 0.3));
    const ck = cl((t - 10.9) / 0.35);
    q.check.setAttribute("transform", "translate(466 36) scale(" + (ck < 1 ? ck * 1.15 : 1) * fade + ")");
    const phase = t < 7.3 ? 0 : t < 10.9 ? 1 : 2;
    if (phase !== scene.phase) {
      scene.phase = phase;
      q.title.textContent = PHASES[phase][0];
      q.sub.textContent = PHASES[phase][1];
      q.d4.style.background = PHASES[phase][2];
    }
  };

  raf = requestAnimationFrame(tick);

  // Dev-only hook to jump the loop to a given second for visual checks.
  if (process.env.NODE_ENV !== "production") {
    window.__bzScene = { seek: (sec) => { scene.t0 = performance.now() - sec * 1000; } };
  }

  return () => {
    cancelAnimationFrame(raf);
    if (window.__bzScene) delete window.__bzScene;
  };
}
